<template>
  <div class="election-map">
    <div class="row row-x" v-if="type === 'electoral'">
      <div class="column small-12 large-9">
        <div class="election-map__content">
          <div class="election-map__title">Which party will win the Electoral College?</div>
          <div class="election-map__toolbar">
            <election-map-toolbar
              :mapStateData="mapStateData"
              type="electoral"
            ></election-map-toolbar>
          </div>
          <div class="election-map__chart" ref="chart"></div>
        </div>
      </div>
      <div class="column small-12 large-3">
        <overview-map :mapOverviewData="mapOverviewData" type="electoral"></overview-map>
      </div>
    </div>
    <div class="row row-x" v-if="type === 'senate'">
      <div class="column small-12 large-9">
        <div class="election-map__content">
          <div class="election-map__title">Which party will win the Senate?</div>
          <div class="election-map__toolbar">
            <election-map-toolbar
              :mapStateData="mapStateDataSenate"
              type="senate"
            ></election-map-toolbar>
          </div>
          <div class="election-map__chart" ref="chart"></div>
          <div class="election-map__special" v-if="false">
            <election-map-special></election-map-special>
          </div>
        </div>
      </div>
      <div class="column small-12 large-3">
        <overview-map :mapOverviewData="mapOverviewDataSenate" type="senate"></overview-map>
      </div>
    </div>
  </div>
</template>

<script src="./election-map.js"></script>
<style src="./election-map.scss" lang="scss"></style>
